import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Date range selector with two DateTimePickers and a Today button.
 * @param {Object} props
 * @param {any} props.from - Start date (Luxon DateTime or ISO string)
 * @param {any} props.to - End date (Luxon DateTime or ISO string)
 * @param {Function} props.onFromChange - Callback for from change
 * @param {Function} props.onToChange - Callback for to change
 * @param {Function} props.onToday - Callback for Today button
 * @param {React.ElementType} props.DateTimePicker - DateTimePicker component
 */
const DateRangeSelector = ({
  from,
  to,
  onFromChange,
  onToChange,
  onToday,
  DateTimePicker,
}) => {
  const { t } = useTranslation('view-data');
  return (
    <Box sx={{ display: 'flex', gap: 2 }} minWidth={500}>
      <DateTimePicker label={t('from')} value={from} onChange={onFromChange} />
      <DateTimePicker label={t('to')} value={to} onChange={onToChange} />
      <Button variant="outlined" sx={{ textWrap: 'nowrap' }} onClick={onToday}>
        {t('today')}
      </Button>
    </Box>
  );
};

export default DateRangeSelector;
